var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonAppFlow32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-AppFlow_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F8B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-AppFlow_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-AppFlow_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.293,5 L16.64,5 L9.109,17.661 L8.593,15.732 L7.626,15.991 L8.396,18.861 L8.334,18.965 L8.44,19.028 L8.579,19.547 L9.085,19.411 L9.193,19.476 L9.259,19.365 L12.135,18.594 L11.877,17.628 L9.991,18.133 L17.208,6 L24.715,6 L28.469,12.5 L24.715,19 L20.804,19 L20.804,20 L25.293,20 L29.623,12.5 L25.293,5 Z M22.11,14.38 L14.991,27 L6.33,27 L2,19.5 L6.33,12 L9.804,12 L9.804,13 L6.908,13 L3.154,19.5 L6.908,26 L14.407,26 L21.258,13.855 L19.331,14.372 L19.073,13.406 L21.945,12.636 L22.003,12.534 L22.107,12.593 L22.629,12.453 L22.767,12.964 L22.874,13.025 L22.812,13.135 L23.583,16.009 L22.616,16.268 L22.11,14.38 Z",
    id: "AWS-AppFlow_32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonAppFlow32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-AppFlow_32.1af95d451f31d6c99f9bc7d4638d6de2.svg";
export { ForwardRef as ReactComponent };